const POPUP_WIDTH = 600
const POPUP_HEIGHT = 700

/**
 * Opens a centered popup window for OAuth authorization.
 * Returns the popup window reference or null if blocked.
 */
export const openCenteredPopup = (authUrl: string): Window | null => {
  const left = window.screenX + (window.outerWidth - POPUP_WIDTH) / 2
  const top = window.screenY + (window.outerHeight - POPUP_HEIGHT) / 2

  const popup = window.open(
    authUrl,
    'oauth-popup',
    `width=${POPUP_WIDTH},height=${POPUP_HEIGHT},left=${left},top=${top},toolbar=no,menubar=no`
  )

  popup?.focus()
  return popup
}
